import styled from "styled-components";

export const ContainerFlex = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.medium};
  height: 100%;

  @media (max-width: 1520px) {
    height: fit-content;
    padding-bottom: 20px;
  }
  @media (max-width: 1100px) {
    flex-direction: column;
    height: auto;
  }
`;

export const ContainerColumnFlex = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;

  @media (max-width: 1100px) {
    flex-direction: column-reverse;
    gap: ${({ theme }) => theme.spacing.medium};
  }
`;

export const CardsColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.medium};

  @media (max-width: 1100px) {
    flex-direction: row;
    width: 100%;
  }

  @media (max-width: 800px) {
    flex-direction: column;
  }
`;

export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.small};
`;

export const ButtonContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: start;
  margin-top: ${({ theme }) => theme.spacing.medium};

  @media (max-width: 1100px) {
    margin-top: 0;
  }
`;

export const ButtonLabel = styled.div`
  margin-left: 5px;
`;

export const DropdownColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;

  @media (max-width: 1450px) {
    width: 400px;
  }
  @media (max-width: 1200px) {
    width: 100%;
  }
  @media (max-width: 1100px) {
    width: 400px;
  }
  @media (max-width: 700px) {
    width: 100%;
  }
`;

export const SmallColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
`;

export const IsEnabled = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.small};
  font-size: 1rem;
  font-weight: 500;
  align-items: center;
`;

export const Flex = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.max};
  height: 100%;
  padding: ${({ theme }) => theme.padding.container};
  margin: 0;
  border-radius: ${({ theme }) => theme.borderRadius.large};
  background-color: ${({ theme }) => theme.colors.background};
  box-shadow: ${({ theme }) => theme.shadow.large};
  flex: 1;

  @media (max-width: 1450px) {
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.medium};
    height: fit-content;
  }
  @media (max-width: 520px) {
    padding: ${({ theme }) => theme.padding.medium};
  }
`;

export const InfoBlock = styled.div`
  display: flex;
  flex: 3;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.medium};
`;

export const ButtonBlock = styled.div`
  display: flex;

  @media (max-width: 520px) {
    width: 100%;

    button {
      width: 100%;
    }
  }
`;

export const SearchContainer = styled.div`
  display: flex;
  width: 100%;
  gap: ${({ theme }) => theme.spacing.small};
`;

export const InputContainer = styled.div`
  width: 320px;

  @media (max-width: 1700px) {
    width: 100%;
  }
  @media (max-width: 1450px) {
    width: 320px;
  }
  @media (max-width: 1200px) {
    width: 100%;
  }
  @media (max-width: 1100px) {
    width: 320px;
  }
  @media (max-width: 700px) {
    width: 100%;
  }
`;

export const OuterHardwareContainer = styled.div`
  display: flex;
  flex: 5;
`;

export const SpaceContainer = styled.div`
  display: flex;
  flex: 1;

  @media (max-width: 1620px) {
    flex: 0.5;
  }
  @media (max-width: 1520px) {
    display: none;
  }
`;

export const HardwareInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 2;
  gap: ${({ theme }) => theme.spacing.small};
  border: 1px solid ${({ theme }) => theme.colors.borderColor};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  background-color: ${({ theme }) => theme.colors.navLink};
  color: ${({ theme }) => theme.colors.white};
  font-weight: 500;
  font-size: ${({ theme }) => theme.typography.medium.fontSize};

  ::selection {
    background-color: ${({ theme }) => theme.colors.primary};
  }

  @media (max-width: 1100px) {
    display: none;
  }
`;

export const HardwareInfoContainerMobile = styled.div`
  display: none;
  flex-direction: column;
  max-height: 728px;
  gap: ${({ theme }) => theme.spacing.small};
  border: 1px solid ${({ theme }) => theme.colors.borderColor};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  background-color: ${({ theme }) => theme.colors.navLink};
  color: ${({ theme }) => theme.colors.white};
  font-weight: 500;
  font-size: ${({ theme }) => theme.typography.medium.fontSize};

  ::selection {
    background-color: ${({ theme }) => theme.colors.primary};
  }

  @media (max-width: 1100px) {
    display: flex;
  }
  @media (max-width: 768px) {
    max-height: 850px;
  }
  @media (max-width: 400px) {
    max-height: 720px;
  }
  @media (min-width: 2050px) {
    max-height: 826px;
  }
  @media (min-width: 2200px) {
    max-height: 940px;
  }
`;

export const HardwareInfoInnerBox = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  gap: ${({ theme }) => theme.spacing.small};
  padding: ${({ theme }) => theme.padding.medium};
`;

export const HardwareInfoHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${({ theme }) => theme.padding.medium}
    ${({ theme }) => theme.padding.medium} 0;
`;

export const HardwareInfoText = styled.div`
  margin: 0;
  color: #f6c74f;
  height: 100%;
`;

export const HardwareInfoH2 = styled.h2`
  margin: 0;
`;

export const HardwareInfoH = styled.p`
  margin: 0;
  margin-bottom: 0.3rem;
  color: #b7f9a6;
  font-weight: 600;
`;

export const HardwareTextLine = styled.div`
  display: flex;
  gap: 5px;
`;

export const PageName = styled.div`
  display: flex;
  height: 40px;
  align-items: center;
`;

export const SessionContainer = styled.div`
  display: flex;
  flex: 5;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.medium};
  // height: fit-content;

  @media (max-width: 1100px) {
    display: none;
  }
`;

export const SessionContainerMobile = styled.div`
  display: none;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.medium};
  padding: ${({ theme }) => theme.padding.container};
  margin: 0;
  border-radius: ${({ theme }) => theme.borderRadius.large};
  background-color: ${({ theme }) => theme.colors.background};
  box-shadow: ${({ theme }) => theme.shadow.large};
  flex: 1;
  width: 100%;
  height: 100%;

  @media (max-width: 520px) {
    padding: ${({ theme }) => theme.padding.medium};
  }

  @media (max-width: 1100px) {
    display: flex;
  }
`;

export const SessionCards = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  @media (max-width: 800px) {
    gap: ${({ theme }) => theme.spacing.small};
  }
`;

export const SessionCard = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.small};
  align-items: center;
`;

export const SessionCardMobile = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.small};

  @media (max-width: 800px) {
    flex-direction: column;
  }
`;

export const SessionNumber = styled.h2`
  margin: 0;
  padding: 0;
  font-size: 1rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.darkBlue};
`;

export const OnlineNumber = styled.h2`
  margin: 0;
  padding: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #196307;
`;

export const NumberTag = styled.div`
  display: flex;
  padding: 1px 15px;
  background-color: #d5e7ff;
  border-radius: ${({ theme }) => theme.borderRadius.large};
  align-items: center;
  justify-content: center;
`;

export const OnlineNumberTag = styled.div`
  display: flex;
  padding: 1px 15px;
  background-color: ${({ theme }) => theme.colors.success};
  border-radius: ${({ theme }) => theme.borderRadius.large};
  align-items: center;
  justify-content: center;
`;

export const ConfirmButtonContainer = styled.div`
  display: flex;
  gap: 0;
`;

export const NoWrapText = styled.span`
  font-family: ${({ theme }) => theme.fonts.body};
  font-size: ${({ theme }) => theme.typography.medium.fontSize};
  font-weight: ${({ theme }) => theme.typography.medium.fontWeight};
  color: ${({ theme }) => theme.colors.text};
  white-space: nowrap;
`;

export const InputNumberMobileFlex = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.small};
`;

export const InputNumberContainer = styled.div`
  width: 200px;

  @media (max-width: 800px) {
    width: 100%;
  }
`;

export const Line = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.small};
  align-items: center;
`;
